// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pageHeaderStyles } from "@awc/Overrides/Widgets/CheckoutShipping/CheckoutShippingHeader";
import { CHECKOUT_BREAKPOINT } from "@awc/XDL/constants";
import { color, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

pageHeaderStyles.container = {
    css: css`
        display: flex;
        column-gap: 36px;
        padding-bottom: 16px;
        border-bottom: 1px solid ${color("common.border")};
        align-items: baseline;
        ${xScreen("lte", CHECKOUT_BREAKPOINT)} {
            padding-bottom: 12px;
        }   
    `,
};
pageHeaderStyles.heading = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
    `,
};